import { FC } from "react";
import { cn } from "@/core/helpers/cn";
import {
  ChatIcon,
  Document1Icon,
  InfoIcon,
  PeopleIcon,
  RadioIcon,
  ShieldIcon,
} from "@/shared/icons";
import { BaseIconProps } from "@/shared/icons/BaseIcon";
import { ChatTab } from "@/domains/chat/constants/chat";
import { ChatState } from "@/domains/chat/slice";

type Props = {
  tabs: ChatState["tabs"];
  currTab: ChatState["currTab"];
  changeTab: (value: ChatState["currTab"]) => void;
};

const icons: Record<ChatState["currTab"], FC<BaseIconProps> | undefined> = {
  [ChatTab.All]: ChatIcon,
  [ChatTab.OOC]: InfoIcon,
  [ChatTab.Faction]: ShieldIcon,
  [ChatTab.Family]: PeopleIcon,
  [ChatTab.News]: Document1Icon,
  [ChatTab.Radio]: RadioIcon,
  [ChatTab.System]: undefined,
};

export default function ChatTabs({ changeTab, currTab, tabs }: Props) {
  return (
    <div className="flex gap-1">
      {tabs.map((tab) => {
        if (currTab === tab) {
          return (
            <button
              key={tab}
              type="button"
              className={cn(
                "relative w-[2.375rem] aspect-square shrink-0 flex items-center justify-center rounded-[0.4rem]",
                "bg-gradient-to-t from-[#707070]/60 to-transparent",
              )}
              onClick={() => changeTab(tab)}
            >
              {icons[tab]({ size: 20, className: "text-white" })}

              <div
                className="absolute inset-0 rounded-[inherit] p-0.5 z-0"
                style={{
                  background: `linear-gradient(90deg, transparent, #707070AA 25%, white 50%, #707070AA 75%, transparent)`,
                  WebkitMask: `linear-gradient(#fff 0 0) content-box, 
                               linear-gradient(#fff 0 0)`,
                  WebkitMaskComposite: "xor",
                  maskComposite: "exclude",
                  clipPath: "inset(calc(100% - 4px) 0 0 0)",
                }}
              />
            </button>
          );
        }
        return (
          <button
            key={tab}
            type="button"
            className={cn(
              "w-[2.375rem] aspect-square shrink-0 flex items-center justify-center rounded-[0.4rem] group",
            )}
            onClick={() => changeTab(tab)}
          >
            {icons[tab]({
              size: 20,
              className: "text-white/70 w-5 group-hover:text-white transition",
            })}
          </button>
        );
      })}
    </div>
  );
}
